import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import UserSideBar from '../../Components/User/UserSideBar'
import UserAddAddress from '../../Components/User/UserAddAddress';

const UserAddAddressPage = () => {
    return (
        <div className="cart-page-bg font">
            <Container>
                <Row className='g-4 py-4'>
                    <Col lg="3" md="4" xs="12">
                        <UserSideBar />
                    </Col>
                    <Col lg="9" md="8" xs="12">
                        <UserAddAddress />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default UserAddAddressPage

